import React from 'react'
import Routes from '../../constants/RouteConstants'
import SortableTable, {ColumnConfig} from '../SortableTable'
import {useSelector} from 'react-redux'
import {selectBuildingsByActiveOrganization} from '../../reducers/selectors'
import HighlightText from '../HighlightText'
import PropTypes from 'prop-types'
import {useHistory} from 'react-router-dom'
import Constant from '../Deliveries/DeliveryConstants'
import RXRIcon from '../RXRIcon'
import EmptyStateIconAndMessage from '../EmptyStateIconAndMessage'

function ListBuildingsWithDocumentsTable(props) {
  const buildingsInOrg = useSelector(selectBuildingsByActiveOrganization)
  const documentsByBuilding = useSelector(state => state.GlobalAdmin.documentsByBuilding)
  const history = useHistory()

  const hasFiltersApplied = !!props.filterTerm

  const lowerFilter = props.filterTerm.toLowerCase()
  const dataToRender = buildingsInOrg
    .map(b => {
      return {
        buildingId: b.id,
        buildingName: b.displayName,
        numberOfDocuments: documentsByBuilding[b.id] ? documentsByBuilding[b.id].length : 0,
      }
    })
    .filter(item => {
      if (!props.filterTerm) {
        return true
      }
      return item.buildingName.toLowerCase().includes(lowerFilter) || item.numberOfDocuments.toString().includes(lowerFilter)
    })

  const columns = [
    new ColumnConfig({
      title: 'Asset Name',
      renderPrimitive: item => item.buildingName,
      render: (r, col) => {
        return (
          <div>
            <HighlightText search={props.filterTerm}>{col.renderPrimitive(r)}</HighlightText>
          </div>
        )
      },
      comparator: ColumnConfig.simpleComparatorGenerator('buildingName'),
    }),
    new ColumnConfig({
      title: '# of Documents',
      renderPrimitive: item => item.numberOfDocuments,
      render: (r, col) => {
        return (
          <div>
            <HighlightText search={props.filterTerm}>{col.renderPrimitive(r)}</HighlightText>
          </div>
        )
      },
      comparator: ColumnConfig.simpleComparatorGenerator('numberOfDocuments'),
    }),
  ]

  if (dataToRender.length > 0) {
    return (
      <SortableTable
        getKey={d => d.buildingId}
        data={dataToRender}
        columns={columns}
        onClickRow={r => props.onClickBuilding(r.buildingId)}
      />
    )
  }

  // Show appropriate empty state
  if (hasFiltersApplied && buildingsInOrg.length > 0) {
    return <EmptyStateIconAndMessage message={'No buildings match the selected filter(s)'} icon={RXRIcon.GLOBAL_ADMIN} />
  }

  return <EmptyStateIconAndMessage message={`No buildings in org`} icon={RXRIcon.GLOBAL_ADMIN} />
}

ListBuildingsWithDocumentsTable.propTypes = {
  filterTerm: PropTypes.string,
  onClickBuilding: PropTypes.func,
}

export default ListBuildingsWithDocumentsTable
